import { ConnectButton } from "~/components/Wallet/ConnectButton";
import { ThemeToggle } from "./ThemeToggle";

export function Header() {
  return (
    <header className="border-b border-[var(--color-border)] bg-[var(--color-bg-primary)]">
      <div className="mx-auto flex max-w-[62rem] items-center justify-between px-4 py-3">
        <a href="/" className="flex items-center">
          <img src="/logo.svg" alt="CrossLlama" className="h-8 md:h-10 [.light_&]:invert" />
        </a>
        <div className="flex items-center gap-3">
          <ThemeToggle />
          <ConnectButton />
        </div>
      </div>
    </header>
  );
}
